import { render, staticRenderFns } from "./DashboardKpi.vue?vue&type=template&id=2fe07936&scoped=true"
import script from "./DashboardKpi.vue?vue&type=script&lang=js"
export * from "./DashboardKpi.vue?vue&type=script&lang=js"
import style0 from "./DashboardKpi.vue?vue&type=style&index=0&id=2fe07936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe07936",
  null
  
)

export default component.exports